import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import productService from "../Services/productService";
import * as xlsx from "xlsx";
import toast from "react-hot-toast";
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa6";
import orderService from "../Services/orderService";
import Loading from "../Components/Loading";
import moment from "moment";
import quotationService from "../Services/quotationService";
import { LoadingDots } from "../Components/LoadingDots";
import DatePicker from "../Components/DatePicker";
import { HiOutlineTrash } from "react-icons/hi";
import { HiOutlineDocumentCheck } from "react-icons/hi2";

const QuotationOrder = () => {
  const location = useLocation();
  const order_products = location.state.products;
  const params = new URLSearchParams(location.search);
  const customer = params.get("customer");
  const qid = params.get("id");

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [initialData, setInitialData] = useState(
    order_products.map((product) => ({
      ...product,
      show: true,
      qty: product.quantity,
    })),
  );
  const [products, setProducts] = useState([]);
  const [file, setFile] = useState(null);
  const [showTable, setShowTable] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState({ id: customer });
  const [selectedQID, setSelectedQID] = useState({ qid: qid });
  const [quotationDate, setQuotationDate] = useState("");
  const [referenceNo, setReferenceNo] = useState("");
  const [staffName, setStaffName] = useState("");
  const [orderDate, setOrderDate] = useState("");
  const [discount, setDiscount] = useState(false);
  const [concludedProducts, setConcludedProducts] = useState(0);
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [reference, setReference] = useState("");
  const [generationLoading, setGenerationLoading] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  const [orderData, setOrderData] = useState({
    customer: "",
    name: "",
    email: "",
    phone: "",
    amount: 0,
  });

  const navigate = useNavigate();

  useEffect(() => {
    if (products.length !== 0) {
      const getProducts = async () => {
        try {
          setInitialData([]);
          setLoading(true);
          let parts = [];
          let quantities = {};
          products.map((single) => {
            parts.push(single["Part Number"]);
            quantities[single["Part Number"]] = single.QTY;
          });
          let response;
          if (discount) {
            response = await productService.searchByVendorAndCustomer(
              parts.toString(),
              selectedCustomer.id,
            );
          } else {
            response = await productService.searchByPart(parts.toString());
          }

          response.products.forEach((item) => {
            console.log("Reference No:", item.reference_no);
          });
          setConcludedProducts(
            order_products.length - response.products.length,
          );
          setInitialData((d) => [
            ...d,
            ...response.products.map((item) => ({
              ...item,
              qty: quantities[item.vendor_code],
              show: true,
            })),
          ]);
          setLoading(false);
          setProducts([]);
        } catch (e) {}
      };
      getProducts();
    }
    console.log(products);
  }, [products]);

  useEffect(() => {
    const fetchQuotation = async () => {
      try {
        const response = await quotationService.single(selectedQID.qid);
        const quotation = response.quotation;

        setQuotationDate(quotation.quotation_date); // ← Save to state
        setReferenceNo(quotation.reference_no); // ← Save to state
        setStaffName(quotation.staff); // ← Save to state

        // console.log("Fetched Quotation Response:", response);
        // console.log("Quotation Date:", quotation.quotation_date);
        // console.log("Reference No:", quotation.reference_no);

        // setOrderDate(response.quotation.quotation_date);
        // setReferenceNo(response.quotation.reference_no);
        // console.log("Selected QID:", selectedQID);
        // console.log("Fetched Quotation Date:", response.quotation.quotation_date);
      } catch (e) {
        console.error("Failed to fetch List", e);
      }
    };
    fetchQuotation();
  }, [selectedQID]);

  // useEffect(() => {
  //     const checkDiscountForCustomer = async () => {
  //         try {

  //             const response = await priceListService.priceListByCustomer(selectedQID.id);
  //             setSelectedQID(response.priceList.id);
  //             console.log("Selected QID:", selectedQID);

  //         } catch (e) {
  //             console.error("Failed to fetch List", e);
  //         }
  //     };

  //     checkDiscountForCustomer();
  // }, [selectedQID]);

  useEffect(() => {
    console.log(orderDate);
  }, [orderDate]);

  useEffect(() => {
    setData(
      initialData.reduce((acc, current) => {
        const isDuplicate = acc.some(
          (item) =>
            item.id === current.id && item.supplier === current.supplier,
        );
        if (!isDuplicate) {
          acc.push(current);
        }
        return acc;
      }, []),
    );
  }, [initialData]);

  useEffect(() => {
    if (data.length !== 0) {
      setShowTable(true);
    }
  }, [data]);

  const handleFileSelect = (e) => {
    e.preventDefault();
    if (e.target.files) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        setFile(data);
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };

  const ProceedFileRead = () => {
    if (file) {
      const workbook = xlsx.read(file, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const json = xlsx.utils.sheet_to_json(worksheet);
      setProducts(json);
    } else {
      toast.error("Please upload any file!");
    }
  };

  const totalQuantity = data.reduce(
    (acc, item) => (item.show ? acc + item.qty : acc),
    0,
  );
  const totalWeight = data.reduce(
    (acc, item) => (item.show ? acc + parseFloat(item.weight || 0) : acc),
    0,
  );
  const totalPrice = data.reduce(
    (acc, item) =>
      item.show ? acc + item.qty * parseFloat(item.price).toFixed(2) : acc,
    0,
  );

  const totalWithVAT = data
    .reduce((acc, item) => {
      if (!item.show) return acc;

      const price = parseFloat(item.price);
      const quantity = item.qty;
      const vat = item.vat_percentage;

      const itemTotal = price * quantity + price * quantity * (vat / 100);

      return acc + itemTotal;
    }, 0)
    .toFixed(2);

  const proceedToCheckout = () => {
    setGenerationLoading(true);
    let submit = { ...orderData };
    const transformedProducts = data.map((item) => ({
      brand: item.brand,
      created_at: item.created_at,
      delivery: item.delivery,
      product: item.product,
      price: parseFloat(item.price).toFixed(2),
      quantity: item.qty,
      show: item.show,
      supplier_code: item.supplier_code,
      supplier: item.supplier,
      title: item.title,
      vat_percentage: item.vat_percentage,
      vendor_code: item.vendor_code,
      weight: item.weight,
    }));

    //submit.quotation = selectedQID?.qid;
    submit.amount = totalPrice;
    submit.vat_amount = totalWithVAT;
    submit.email = selectedCustomer?.email;
    submit.phone = selectedCustomer?.phone_number;
    submit.customer = selectedCustomer?.id;
    submit.order_date = date;
    submit.quotation_date = quotationDate;
    submit.reference_no = referenceNo;
    submit.staff = staffName;
    submit.recipient =
      selectedCustomer?.first_name + selectedCustomer?.last_name;
    console.log(submit?.recipent);
    console.log(submit?.customer);
    submit.products = transformedProducts.filter((value) => value.show);
    console.log(submit);

    // orderService.submitOrder(submit).then((response) => {
    //     if (response.responseCode === 200) {
    //         navigate("/order");
    //     }
    // });

    if (selectedQID?.qid) {
      quotationService
        .updateStatus(selectedQID.qid, { status: "accepted" })
        .then((response) => {
          console.log("Quotation status updated");
          orderService
            .submitOrder(submit)
            .then((response) => {
              if (response.responseCode === 200) {
                setGenerationLoading(false);
                navigate("/order");
              }
            })
            .catch((error) => {
              console.error("Error submitting order:", error);
              setGenerationLoading(false);
            });
        })
        .catch((error) => {
          console.error("Error updating quotation status:", error);
          setGenerationLoading(false);
        });
    }
  };

  const handleIncrement = (v, id) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === id && v > 0 ? { ...item, qty: v } : item,
      ),
    );
  };

  const handleDecrement = (v, id) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === id && v >= 0 ? { ...item, qty: v } : item,
      ),
    );
  };

  const initialDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  const downloadQuotation = () => {
    const summary = [
      { Weight: "Total Quantity", Delivery: totalQuantity },
      { Weight: "Total Weight", Delivery: totalWeight },
      { Weight: "Total Price", Delivery: totalPrice.toFixed(2) },
    ];

    const transformedData = data.map((item) => ({
      "Vendor Code": item.vendor_code,
      Brand: item.brand,
      Title: item.title,
      "Ordered Quantity": item.qty,
      Price: item.price,
      Weight: item.weight,
      Delivery: item.delivery,
    }));

    const blankRows = [{}, {}, {}];
    const fullData = [...transformedData, ...blankRows, ...summary];

    const worksheet = xlsx.utils.json_to_sheet(fullData);

    const workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, worksheet, "Quotation");

    const excelBuffer = xlsx.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "quotation.xlsx");
    document.body.appendChild(link);
    link.click();

    link.parentNode.removeChild(link);
  };

  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg bg-white min-h-[calc(100vh-48px)]">
      <div className=" text-center font-extrabold text-3xl text-secondary">
        Quotation --to-- Order
      </div>
      <div className="flex justify-center mt-10">
        <div className="grid grid-cols-5 w-[70%] items-center justify-center gap-4">
          <input
            type="text"
            name="from"
            placeholder={"Reference"}
            value={reference}
            onChange={(e) => setReference(e.target.value)}
            className="primary-input"
          />
          <DatePicker value={date} onChange={(e) => setDate(e.target.value)} />
          <div className="flex flex-row justify-end py-2 rounded-3xl col-span-3">
            <input
              onChange={(e) => handleFileSelect(e)}
              type="file"
              className="primary-input !rounded-r-none col-span-4
                        file:mr-4 file:py-[2px] file:px-3 file:rounded-md file:duration-300
                        file:border-0 file:text-sm file:font-medium
                      file:bg-white file:text-black
                      hover:file:bg-primary hover:file:text-white"
            />
            <button
              onClick={() => ProceedFileRead()}
              className="bg-primary px-4 w-40 py-1 rounded-r-[0.5rem] text-white font-medium text-sm"
            >
              Proceed
            </button>
          </div>
        </div>
      </div>
      <div className="flex justify-center mt-10">
        <p className="text-center mt-5 bg-white shadow-md border rounded-md py-2 px-4 text-cyan-600 w-fit font-semibold text-sm">
          {concludedProducts} Products Excluded
        </p>
      </div>
      {loading ? (
        <div className="flex items-center justify-center py-8">
          <Loading />
        </div>
      ) : (
        <>
          {showTable && (
            <>
              <div className="flex flex-row justify-between items-center mt-8">
                <button
                  onClick={() => setShowDetails((prev) => !prev)}
                  className="flex items-center gap-2 text-xs font-semibold px-4 py-2 rounded-lg border border-gray-200 bg-gray-50 hover:bg-gray-100 hover:shadow transition-all duration-300"
                >
                  <svg
                    className={`w-4 h-4 transition-transform duration-300 ${showDetails ? "rotate-180" : ""}`}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                  </svg>
                  {showDetails ? "Hide Details" : `Show Details`}
                </button>
              </div>

              <div
                className={`transition-all duration-500 overflow-hidden ${showDetails ? "opacity-100 mt-4" : "max-h-0 opacity-0"}`}
              >
                <div className="table-div">
                  <table className="w-full">
                    <thead>
                      <tr className="border-y-2 text-left w-full text-black text-[10px] font-bold">
                        <th className="text-center w-[8%] py-4">Qty</th>
                        <th className="w-[8%]">Brand</th>
                        <th className="w-[8%]">Part No.</th>

                        <th className="w-[14%]">Title</th>
                        <th className="w-[4%]">Stock</th>
                        <th className="w-[8%]">Weight (Kg)</th>
                        <th className="w-[8%]">Total Weight</th>
                        <th className="w-[8%]">Delivery</th>
                        <th className="w-[8%]">Price</th>
                        <th className="w-[8%]">Total Price</th>
                        <th className="w-[4%]">VAT</th>
                        <th className="w-[8%] text-center">
                          Total Price Incl VAT
                        </th>
                        <th className="w-[8%] text-center">Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((data, index) => (
                        <tr
                          key={index}
                          className={`border-b border-gray-200  ${
                            data.show ? "" : "hidden"
                          }`}
                        >
                          <td className="py-4 text-center text-[12px] w-[8%] bg-white">
                            <div className="flex rounded-md justify-center items-center ">
                              <div className="flex flex-row items-center gap-1">
                                <div>
                                  <FaMinus
                                    className="cursor-pointer p-1 h-5 w-5 bg-red-500 rounded-md text-white"
                                    onClick={() =>
                                      handleDecrement(data.qty - 1, data.id)
                                    }
                                  />
                                </div>
                                <p
                                  className={`w-[20px] text-center font-extrabold rounded-md`}
                                >
                                  {data.qty}
                                </p>
                                <div>
                                  <FaPlus
                                    className="cursor-pointer p-1 h-5 w-5 bg-green-500 rounded-md text-white"
                                    onClick={() =>
                                      handleIncrement(data.qty + 1, data.id)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="py-4 text-left font-bold text-[12px] w-[8%] bg-white">
                            {data.brand}
                          </td>
                          <td className="py-4  text-left text-[12px] w-[8%] bg-white">
                            {data.vendor_code}
                          </td>

                          <td className="py-4 text-left text-[12px] w-[14%] bg-white">
                            {data.title}
                          </td>
                          <td className="py-4 text-left text-[12px] w-[4%] bg-white">
                            {data.quantity}
                          </td>
                          <td className="py-4 text-left text-[12px] w-[8%] bg-white">
                            {data.weight}
                          </td>
                          <td className="py-4 text-left text-[12px] w-[8%] bg-white">
                            {parseFloat(data.quantity * data.weight).toFixed(2)}
                          </td>
                          <td className="py-4 text-left text-[12px] w-[8%] bg-white">
                            {data.delivery}
                          </td>
                          <td className="py-4 text-left text-[12px] w-[8%]">
                            <input
                              className={`w-16 text-center border-gray-500 py-2 bg-gray-100 rounded-lg`}
                              value={parseFloat(data.price).toFixed(2)}
                            />
                          </td>
                          <td className="py-4 text-left font-bold text-[12px] w-[8%] ">
                            {parseFloat(
                              parseFloat(data.price).toFixed(2) * data.qty,
                            ).toFixed(2)}
                          </td>
                          <td className="py-4 text-left text-[12px] w-[4%]">
                            {(
                              parseFloat(data.price).toFixed(2) *
                              data.qty *
                              (data.vat_percentage / 100)
                            ).toFixed(2)}
                          </td>
                          <td className="py-4 text-center text-[12px] w-[8%]">
                            {(
                              parseFloat(data.price) * data.qty +
                              parseFloat(data.price) *
                                data.qty *
                                (data.vat_percentage / 100)
                            ).toFixed(2)}
                          </td>
                          <td className=" py-4 text-[12px] w-[8%] bg-white">
                            <div className="flex justify-center gap-4">
                              <HiOutlineTrash
                                onClick={() => initialDelete(data.id)}
                                className="h-4 w-4 text-red-500 hover:cursor-pointer"
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="flex flex-row justify-center gap-4 mt-4 flex-wrap">
                {[
                  {
                    label: "Total Price",
                    value: parseFloat(totalPrice).toFixed(2),
                  },
                  {
                    label: "Total Price Incl. VAT",
                    value: `${parseFloat(totalWithVAT).toFixed(2)} AED`,
                  },
                  {
                    label: "Total Weight",
                    value: `${parseFloat(totalWeight).toFixed(2)} AED`,
                  },
                  {
                    label: "Total Price Incl. VAT",
                    value: `${parseFloat(totalQuantity).toFixed(0)} AED`,
                  },
                ].map((stat) => (
                  <div
                    key={stat.label}
                    className="flex flex-col bg-gray-50 border border-gray-200 rounded-xl px-5 py-3"
                  >
                    <span className="text-[10px] text-gray-400 uppercase tracking-wide font-semibold">
                      {stat.label}
                    </span>
                    <span className="text-sm font-bold text-gray-800 mt-1">
                      {stat.value}
                    </span>
                  </div>
                ))}
              </div>
              <div className="flex justify-center mt-10">
                <div>
                  {" "}
                  <div>
                    {generationLoading ? (
                      <div className="flex flex-row justify-center items-center button-primary gap-4">
                        <LoadingDots />
                        <p>Processing</p>
                      </div>
                    ) : (
                      <button
                        onClick={() => proceedToCheckout()}
                        className="bg-white text-black border font-medium text-xs px-8 py-4 rounded-lg shadow-sm hover:shadow-lg duration-300 transition-all flex flex-row items-center overflow-hidden group"
                      >
                        <HiOutlineDocumentCheck className="text-lg w-0 opacity-0 group-hover:w-6 group-hover:opacity-100 group-hover:mr-2 transition-all duration-300 ease-in-out" />
                        Generate Order
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}{" "}
        </>
      )}
    </main>
  );
};

export default QuotationOrder;
